/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export interface FnoActivationFormState {
  status: 'idle' | 'loading' | 'success' | 'error';
  fnoActivationDocumentName: string,
  fnoActivationDocument: File | null,
  fnoSkipped: boolean,
  fnoActivationMethod: 'manual' | 'setu',
  setuRedirectionUrl: string,
  isSetuVerificationDone:boolean,
  error: {
    isError: boolean,
    type: string | null,
    message: string | null
  }
}

// Initial State
const initialState: FnoActivationFormState = {
  status: 'idle',
  fnoActivationDocumentName: '',
  fnoActivationDocument: null,
  fnoSkipped: false,
  fnoActivationMethod: 'setu',
  setuRedirectionUrl: '',
  isSetuVerificationDone: false,
  error: {
    isError: false,
    type: null,
    message: '',
  },
};

export const fnoActivationFormSlice = createSlice({
  name: 'fnoActivationForm',
  initialState,
  reducers: {
    saveFnoActivationData: (state, action) => {},
    setFnoActivationData: (state, action) => {
      state.fnoActivationDocumentName = action.payload.documentName;
      state.fnoActivationDocument = action.payload.documentFile;
      state.status = 'success';
    },
    setFnoActivationFormError: (state, action) => {
      state.error = action.payload;
      state.status = 'error';
    },
    setFnoSkipped: (state, action) => {
      state.fnoSkipped = action.payload;
      state.status = 'success';
    },
    setFnoActivationFormStatus: (state, action) => {
      state.status = action.payload;
    },
    clearFnoActivationFormError: (state) => {
      state.error = {
        isError: false,
        type: null,
        message: '',
      };
      state.status = 'idle';
    },
    startSetuVerification: () => {},
    setSetuVerificationDetails: (state, action) => {
      state.setuRedirectionUrl = action.payload.redirectionUrl;
    },
    checkSetuVerificationStatus: (state, action) => {
    },
    setSetuVerificationStatus: (state, action) => {
      state.status = action.payload.status;
      state.isSetuVerificationDone = action.payload.isSetuVerificationDone
    },
  },
});

// Actions
export const {
  saveFnoActivationData, setFnoActivationFormError, setFnoActivationFormStatus,
  clearFnoActivationFormError, setFnoActivationData, setFnoSkipped, startSetuVerification, setSetuVerificationDetails,
  checkSetuVerificationStatus, setSetuVerificationStatus,
} = fnoActivationFormSlice.actions;

// Slice Reducer
export default fnoActivationFormSlice.reducer;
